import { isEmpty, isNumber, values } from "lodash";
import React, { useEffect, useState } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import pathObj from "../utils/apiPath";
import obj from "../utils/constants";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
const SetLimitBlock = ({ onClose, object, getMatchData }) => {
  const { register, handleSubmit, setValue } = useForm();
  const [data, setData] = useState(obj.settingArrayNew);
  const handelChange = (object) => {
    if (object?.length > 0) {
      let betfair = object?.find((res) => {
        return res?.type == "betFaire";
      });
      let bookmaker = object?.find((res) => {
        return res?.type == "bookmaker";
      });
      let fancy = object?.find((res) => {
        return res?.type == "fancy";
      });
      let sportBook = object?.find((res) => {
        return res?.type == "sportBook";
      });
      if (!isEmpty(betfair)) {
        setValue("betFaireMin", betfair?.minAmount);
        setValue("betFaireMax", betfair?.maxAmount);
        setValue("betFaireBetDelay", betfair?.betDelay);
        setValue("betFaireMaxProfit", betfair?.maxProfit);
        setValue("betFaireOddsLimit", betfair?.oddsLimit);
      }
      if (!isEmpty(bookmaker)) {
        setValue("bookmakerMin", bookmaker?.minAmount);
        setValue("bookmakerMax", bookmaker?.maxAmount);
        setValue("bookmakerBetDelay", bookmaker?.betDelay);
        setValue("bookmakerMaxProfit", bookmaker?.maxProfit);
        setValue("bookmakerOddsLimit", bookmaker?.oddsLimit);
      }
      if (!isEmpty(fancy)) {
        setValue("fancyMin", fancy?.minAmount);
        setValue("fancyMax", fancy?.maxAmount);
        setValue("fancyBetDelay", fancy?.betDelay);
        setValue("fancyMaxProfit", fancy?.maxProfit);
        setValue("fancyOddsLimit", fancy?.oddsLimit);
      }
      if (!isEmpty(sportBook)) {
        setValue("sportBookMin", sportBook?.minAmount);
        setValue("sportBookMax", sportBook?.maxAmount);
        setValue("sportBookBetDelay", sportBook?.betDelay);
        setValue("sportBookMaxProfit", sportBook?.maxProfit);
        setValue("sportBookOddsLimit", sportBook?.oddsLimit);
      }
    }
  };
  const onSubmit = async (body) => {
    let obj = [
      {
        type: "betFaire",
        minAmount: body?.betFaireMin,
        maxAmount: body?.betFaireMax,
        betDelay: body?.betFaireBetDelay,
        maxProfit: body?.betFaireMaxProfit,
        oddsLimit: body?.betFaireOddsLimit,
      },
      {
        type: "bookmaker",
        minAmount: body?.bookmakerMin,
        maxAmount: body?.bookmakerMax,
        betDelay: body?.bookmakerBetDelay,
        maxProfit: body?.bookmakerMaxProfit,
        oddsLimit: body?.bookmakerOddsLimit,
      },
      {
        type: "fancy",
        minAmount: body?.fancyMin,
        maxAmount: body?.fancyMax,
        betDelay: body?.fancyBetDelay,
        maxProfit: body?.fancyMaxProfit,
        oddsLimit: body?.fancyOddsLimit,
      },
      {
        type: "sportBook",
        minAmount: body?.sportBookMin,
        maxAmount: body?.sportBookMax,
        betDelay: body?.sportBookBetDelay,
        maxProfit: body?.sportBookMaxProfit,
        oddsLimit: body?.sportBookOddsLimit,
      },
    ];
    let objNew = {};
    if (object?.type == "series") {
      objNew = {
        seriesId: object?.data?.seriesId,
        limit: obj,
      };
    } else {
      objNew = { eventId: object?.data?.eventId, limit: obj };
    }

    try {
      let response = await apiPost(pathObj.updateBlockListinStatus, objNew);
      if (response?.data?.success) {
        toast.success(response?.data?.message);
        getMatchData();
        onClose();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (object?.data?.limit?.length > 0) {
      handelChange(object?.data?.limit);
    }
  }, [object]);
  return (
    <Modal size="2xl" show={true} onHide={onClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="modal-title-status">
          {" "}
          Update Bet Config -{" "}
          {object?.type == "series"
            ? object?.data?.seriesName
            : object?.data?.eventName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="">
          <Container fluid>
            <Form onSubmit={handleSubmit(onSubmit)}>
              {data &&
                data?.map((item, index) => {
                  return (
                    <div className="d-flex mb-3">
                      <h2
                        style={{
                          width: "20%",
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                        className="common-heading "
                      >
                        {obj.settingHeading[item.type]}
                      </h2>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {" "}
                        <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Min Amount
                            </Form.Label>
                          )}
                          <Form.Control
                            type="number"
                            name="minAmount"
                            placeholder="Min Amount"
                            {...register(`${item?.type}Min`, {
                              required: {
                                values: false,
                              },
                              // validate: (value) => {
                              //   if (
                              //     Number(watch(`${item?.type}Min`)) >
                              //     Number(value)
                              //   ) {
                              //     return "max should be greater than min";
                              //   }
                              // },
                            })}
                          />
                        </Form.Group>
                        <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Max Amount
                            </Form.Label>
                          )}
                          <Form.Control
                            type="number"
                            name="maxAmount"
                            placeholder="Max Amount"
                            {...register(`${item?.type}Max`, {
                              required: {
                                values: false,
                              },
                              // validate: (value) => {
                              //   if (
                              //     Number(watch(`${item?.type}Min`)) >
                              //     Number(value)
                              //   ) {
                              //     return "max should be greater than min";
                              //   }
                              // },
                            })}
                          />
                        </Form.Group>
                        <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Max Profit
                            </Form.Label>
                          )}
                          <Form.Control
                            type="number"
                            name="exposure"
                            placeholder="Max Profit"
                            {...register(`${item?.type}MaxProfit`, {
                              required: {
                                values: false,
                              },
                              // validate: (value) => {
                              //   if (value == 0 && !isEmpty(value)) {
                              //     return "value should be greater than zero";
                              //   }
                              // },
                            })}
                          />
                        </Form.Group>
                        <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start  flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Bet Delay
                            </Form.Label>
                          )}
                          <Form.Control
                            type="number"
                            name="betDelay"
                            placeholder="Bet Delay"
                            {...register(`${item?.type}BetDelay`, {
                              required: {
                                values: false,
                              },
                              validate: (value) => {
                                if (value == 0 && !isEmpty(value)) {
                                  return "value should be greater than zero";
                                }
                              },
                            })}
                          />
                        </Form.Group>
                        {/* <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Back
                            </Form.Label>
                          )}
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            className="p-0"
                            checked={status}
                            onClick={(e) => {
                              setStatus(e?.target.checked);
                            }}
                          />
                        </Form.Group>
                        <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Lay
                            </Form.Label>
                          )}
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            className="p-0"
                            checked={status}
                            onClick={(e) => {
                              setStatus(e?.target.checked);
                            }}
                          />
                        </Form.Group> */}
                        <Form.Group
                          style={{ marginRight: "15px" }}
                          className="d-flex align-items-start flex-column"
                        >
                          {index == 0 && (
                            <Form.Label
                              style={{ fontSize: "16px" }}
                              className="pe-2 mb-2 w-lg-auto"
                            >
                              Odds Limit
                            </Form.Label>
                          )}
                          <Form.Control
                            type="number"
                            name="betDelay"
                            placeholder="Odds Limit"
                            {...register(`${item?.type}OddsLimit`, {
                              required: {
                                values: false,
                              },
                            })}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  );
                })}{" "}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  type="submit"
                  style={{
                    color: "black",
                    padding: "6px",
                    marginRight: "10px",
                  }}
                  className="green-btn"
                >
                  Set Limit
                </Button>{" "}
                <Button
                  type="button"
                  onClick={() => onClose()}
                  className="theme_light_btn btn btn-primary"
                >
                  Cancel
                </Button>
              </div>
            </Form>
          </Container>
        </section>
      </Modal.Body>
    </Modal>
  );
};

export default SetLimitBlock;
